import { render, staticRenderFns } from "./ReportSlider.vue?vue&type=template&id=b1c5767c"
import script from "./ReportSlider.vue?vue&type=script&lang=js"
export * from "./ReportSlider.vue?vue&type=script&lang=js"
import style0 from "./ReportSlider.vue?vue&type=style&index=0&id=b1c5767c&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b1c5767c')) {
      api.createRecord('b1c5767c', component.options)
    } else {
      api.reload('b1c5767c', component.options)
    }
    module.hot.accept("./ReportSlider.vue?vue&type=template&id=b1c5767c", function () {
      api.rerender('b1c5767c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/elements/ReportSlider.vue"
export default component.exports